import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeTTS } from '../traitTypes/TraitTypeTTS';
import { runtime } from '../../../classes/runtime/Runtime';
export class TraitRegistryMediaTTS extends TraitRegistryCategory {
    label = 'Text to Speech';
    constructor(parent) {
        super(parent);
        super.init();
    }
    tts = () => new TraitTypeTTS({
        label: 'Text To Speech',
        multiple: true,
        icon: 'far fa-file-audio',
        key: 'tts',
        creates: ['mediaSequence'],
        createTraits: ({ at }) => {
            if (!at.trait.value)
                return [];
            const medSeqTrait = runtime.class.Trait.fromSerialized({
                key: 'mediaSequence',
                traitGroup: at.trait.traitGroup,
                value: {
                    type: 'medseq',
                    mediumLabel: at.trait.value.mediumLabel,
                    sequenceName: 'auto',
                },
            });
            medSeqTrait.isGenerated = true;
            return [medSeqTrait];
        },
    });
}
